import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

interface EntityFilterProps {
  entities: string[];
  value: string;
  onChange: (value: string) => void;
}

const EntityFilter: React.FC<EntityFilterProps> = ({
  entities,
  value,
  onChange,
}) => {
  const uniqueEntities = Array.from(new Set(entities)).sort((a, b) => {
    const numA = parseFloat(a);
    const numB = parseFloat(b);
  
    // Se ambos forem números, ordena em ordem crescente
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }
  
    // Se não forem números, ordena alfabeticamente
    return a.localeCompare(b, "pt-BR", { sensitivity: "base", numeric: true });
  });
  

  // Estado para controlar se o dropdown está aberto
  const [open, setOpen] = useState(false);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setOpen(false); // Fecha o dropdown ao pressionar Enter
    }
  };

  return (
    <Autocomplete
      options={uniqueEntities} // Passa apenas entidades únicas
      value={value}
      onInputChange={(_, newValue) => onChange(newValue)} // Atualiza ao digitar
      onChange={(_, newValue) => onChange(newValue || "")} // Atualiza ao selecionar
      open={open} // Controla se o dropdown está aberto
      onOpen={() => setOpen(true)} // Abre o dropdown ao focar
      onClose={() => setOpen(false)} // Fecha o dropdown ao perder o foco
      renderInput={(params) => (
        <TextField
          {...params}
          label="Filtrar entidade"
          placeholder="Todas"
          size="small"
          variant="outlined"
          sx={{
            width: "250px",
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#444444" : "#ffffff",
            borderRadius: "4px",
            fontSize: "0.875rem", // Ajuste do tamanho da fonte
            "& .MuiInputBase-input": {
              fontSize: "0.875rem", // Garante que o input interno tenha o mesmo tamanho
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.875rem", // Ajusta o label
            },
          }}
          onKeyDown={handleKeyDown} // Adiciona o evento de tecla para fechar com Enter
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          key={option} // Usa o valor da opção como chave
          style={{
            fontSize: "0.75rem", // Reduz o tamanho do texto no dropdown
            padding: "4px 8px", // Ajusta o padding para um layout mais compacto
          }}
        >
          {option}
        </li>
      )}
    />
  );
};

export default EntityFilter;
